import React, { PureComponent } from 'react';
import { PropTypes } from 'prop-types';
import moment from 'moment';
import ActivityPerms from 'components/AccessControl/permissions.json';
import AccessControl from 'components/AccessControl';
import { Link } from 'react-router-dom';
import ActiveChip from 'components/Common/ActiveChip';

class AccountCustomerList extends PureComponent {
  static propTypes = {
    onConfirmCustomerUnlink: PropTypes.func.isRequired,
    account: PropTypes.shape(),
    defaultWhdCustomerId: PropTypes.number,
    jointAccountsEnabled: PropTypes.bool,
    permissions: PropTypes.arrayOf(PropTypes.string),
  };

  static defaultProps = {
    account: {
      customers: []
    },
    defaultWhdCustomerId: 0,
    jointAccountsEnabled: false,
    permissions: null
  };

  static getCustomerName(item) {
    if (item === null || (!item.customerId && !item.name)) {
      return 'N/A';
    }

    let customerName = item.customerId;

    if (!customerName) {
      customerName = item.name;
    } else if (item.name !== null && item.name !== customerName) {
      customerName = `${ customerName } - ${ item.name }`;
    }

    return customerName;
  }

  foreignPartnersSuffix(id) {
    const { account } = this.props;
    if (account && account.customers) {
      const selectedCustomer = account.customers.filter(a => a.customerDbId === id);
      if (selectedCustomer && selectedCustomer.length === 1) {
        const certData = selectedCustomer[0].formCertificationData ?? selectedCustomer[0].importCertificationData;
        if (certData && certData.hasForeignPartners === true) {
          const classificationData = selectedCustomer[0].reportingClassification ?? selectedCustomer[0].withholdingClassification;
          if (classificationData && classificationData.chapter3Status === 8) {
            return ' - With Foreign Partners';
          }
          if (classificationData && classificationData.chapter3Status === 10) {
            return ' - With Foreign Beneficiaries';
          }
        }
      }
    }
    return '';
  }

  render() {
    const { account, onConfirmCustomerUnlink, defaultWhdCustomerId, jointAccountsEnabled, permissions } = this.props;
    return (
      <div>
        <div>
          <table className="table table-striped table-hover table-bordered" id="account-customers-table">
            <thead>
              <tr>
                <th>Customer</th>
                <th>Capacity</th>
                <th>U.S. Classifications</th>
                <th>CRS Status</th>
                <th>CARF Status</th>
                <th>Effective From</th>
                <th>Effective To</th>
                { jointAccountsEnabled && <AccessControl allowedPermissions={ [ActivityPerms.accountEdit] }>
                  <th>Unlink</th>
                </AccessControl> }
              </tr>
            </thead>
            <tbody>
              { (account != null && account.customers != null && account.customers.length > 0)
                && account.customers.map(customerDtl => customerDtl != null && <tr key={ customerDtl.customerDbId }>
                  <td align="center">
                    { AccessControl.hasPermission(permissions, [ActivityPerms.customerPageView, ActivityPerms.customerEdit])
                      ? <Link className="text-bold" to={ `/customer/${ customerDtl.customerDbId }` }>{ AccountCustomerList.getCustomerName(customerDtl) }</Link>
                      : AccountCustomerList.getCustomerName(customerDtl) }
                    <ActiveChip isActive={ customerDtl.isActive } />{ defaultWhdCustomerId === customerDtl.customerDbId && <span className="chip">WHD</span> }
                  </td>
                  <td align="center">{ customerDtl.capacityString != null ? customerDtl.capacityString : '' }</td>
                  <td align="center">
                    <b>Chapter 3 Status: </b>{customerDtl.reportingClassification?.chapter3StatusDescription ?? 'N/A'}
                    {this.foreignPartnersSuffix(customerDtl.customerDbId)}<br />
                    <b>Chapter 4 Status: </b>{customerDtl.reportingClassification?.chapter4StatusDescription ?? 'N/A' }<br />
                    <b>W9 Status: </b>{customerDtl.reportingClassification?.w9StatusDescription ?? 'N/A'}<br />
                    <b>Updated By: </b>{customerDtl.reportingClassification?.recordSourceDescription ?? 'N/A' }
                  </td>
                  <td align="center">
                    {customerDtl.crsClassification?.classificationDescription ?? 'N/A' }<br />
                    <b>Updated By: </b>{customerDtl.crsClassification?.recordSourceDescription ?? 'N/A' }
                  </td>
                  <td align="center">
                    {customerDtl.carfClassification?.classificationDescription ?? 'N/A' }<br />
                    <b>Updated By: </b>{customerDtl.carfClassification?.recordSourceDescription ?? 'N/A' }
                  </td>
                  <td align="center">{ customerDtl.validFrom != null ? moment(customerDtl.validFrom).format('MMM DD, YYYY') : '' }</td>
                  <td align="center">{ customerDtl.linkedTo != null ? customerDtl.linkedTo : '' }</td>
                  { jointAccountsEnabled && <AccessControl allowedPermissions={ [ActivityPerms.accountEdit] }>
                    <td>
                      <center>
                        <button
                          type="submit"
                          title="Unlink Customer"
                          className="btn btn-sm btn-danger"
                          onClick={ () => onConfirmCustomerUnlink(customerDtl.customerDbId) }
                          id={ `account-customers-table-unlink-button-${ customerDtl.customerDbId }` }
                        ><span className="icon icon-link" /></button>
                      </center>
                    </td>
                  </AccessControl> }
                </tr>) }
              { (!account || !account.customers || account.customers.length === 0)
                && <tr><td colSpan="8" style={ { textAlign: 'center' } }>
                  <p id="account-customers-table-no-data-name"><b>No Data to Show</b></p></td></tr> }
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default AccountCustomerList;
